import { rest } from 'utils';

export default {
  create: ({ properties, dcId }) => rest.post({ url: `datacenters/${dcId}/volumes`, body: { properties } }),
  createInServer: ({ properties, serverId, dcId }) => rest.post({ url: `datacenters/${dcId}/servers/${serverId}/volumes`, body: { properties } }),
  get: ({ dcId, id }) => rest.get({ url: `datacenters/${dcId}/volumes/${id}` }),
  getAll: ({ dcId }) => rest.get({ url: `datacenters/${dcId}/volumes` }),
  update: ({ dcId, id, properties }) => rest.put({ url: `datacenters/${dcId}/volumes/${id}`, body: { properties } }),
  delete: ({ dcId, id }) => rest.delete({ url: `datacenters/${dcId}/volumes/${id}` }),
  createSnapshot: ({ dcId, id }) => rest.request({ url: `datacenters/${dcId}/volumes/${id}/create-snapshot`, method: 'post', responseType: 'text' }),
};
